import React, { type HTMLAttributes } from 'react'
import { hexColors } from '@mobi/settings'
import styled from '@emotion/styled'

type Props = {
  count: number
  showPlusIcon?: boolean
} & HTMLAttributes<HTMLSpanElement>

export const Badge: React.FC<Props> = ({ count, showPlusIcon = false, ...props }) => {
  return (
    <BadgeStyled {...props} style={{ fontSize: showPlusIcon ? '1rem' : '1.2rem' }}>
      {count}
      {showPlusIcon && '+'}
    </BadgeStyled>
  )
}

const BadgeStyled = styled.span({
  display: 'inline-block',
  padding: '0.2rem 1rem 0 1rem',
  borderRadius: '2rem',
  marginRight: '0.5rem',
  textAlign: 'center',
  backgroundColor: hexColors.deepLilac,
  color: hexColors.white,
})
